import { useLocation, useNavigate } from 'react-router-dom';
import {
  LayoutDashboard,
  Package,
  ShoppingCart,
  Users,
  MessageSquare,
  Bot,
  Menu,
} from 'lucide-react';

const BOTTOM_ITEMS = [
  { id: 'dashboard', label: 'Home', icon: LayoutDashboard, path: '/' },
  { id: 'products', label: 'Products', icon: Package, path: '/products' },
  { id: 'orders', label: 'Orders', icon: ShoppingCart, path: '/orders' },
  { id: 'customers', label: 'Customers', icon: Users, path: '/customers' },
  { id: 'tickets', label: 'Tickets', icon: MessageSquare, path: '/tickets' },
  { id: 'bot', label: 'Bot', icon: Bot, path: '/bot' },
];

export function MobileBottomNav({ onMenuClick }: { onMenuClick: () => void }) {
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (path: string) =>
    path === '/' ? location.pathname === '/' : location.pathname.startsWith(path);

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 border-t border-white/[0.06] bg-background/95 px-2 pb-safe pt-2 backdrop-blur-xl lg:hidden">
      <div className="flex items-center justify-around">
        {BOTTOM_ITEMS.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          return (
            <button
              key={item.id}
              onClick={() =>
                item.id === 'menu' ? onMenuClick() : navigate(item.path)
              }
              className="flex flex-1 flex-col items-center gap-1 py-2"
            >
              <div
                className={`flex h-8 w-8 items-center justify-center rounded-xl transition-colors ${
                  active
                    ? 'bg-primary/10 text-primary'
                    : 'text-muted'
                }`}
              >
                <Icon size={20} />
              </div>
              <span
                className={`text-[10px] font-medium ${
                  active ? 'text-primary' : 'text-muted'
                }`}
              >
                {item.label}
              </span>
            </button>
          );
        })}
        <button
          onClick={onMenuClick}
          className="flex flex-1 flex-col items-center gap-1 py-2"
        >
          <div className="flex h-8 w-8 items-center justify-center rounded-xl text-muted">
            <Menu size={20} />
          </div>
          <span className="text-[10px] font-medium text-muted">More</span>
        </button>
      </div>
    </nav>
  );
}
